<template>
  <div class="related-row">
    <div class="table-container">
      <vxe-grid
        border
        show-overflow
        resizable
        ref="deductionRow"
        class="vxe-table-element"
        size="mini"
        align="center"
        :auto-resize="true"
        :data="tableData"
        :toolbar="{}"
        :edit-rules="tableRules"
        :edit-config="{ trigger: 'click', mode: 'row' }"
        @select-change="handleSelectionChange"
        @select-all="handleSelectionChange"
        :valid-config="{ autoPos: true, message: 'inline' }"
        @edit-closed="closeEditTableHandler"
        height="150"
      >
        <template v-slot:buttons v-if="isCreate">
          <el-button
            @click="deleteBtnClickHandler"
            size="small"
            type="danger"
            class="vxe-btn-delete"
            >删除</el-button
          >
        </template>
        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in tableColumnList"
          :key="index"
          :type="item.type"
          :fixed="item.fixed"
          :field="item.field"
          :title="item.title"
          :width="item.width"
          :sortable="item.sortable"
          :edit-render="item.editRender"
        >
          <template v-slot="{ row }">
            <span>{{ row[item.field] }}</span>
          </template>
          <template v-slot:edit="{ row }">
            <!-- 计算说明 -->
            <el-input
              v-if="item.editRender.name == 'deductionDesc'"
              v-model="row[item.field]"
              @input="() => handleChange(row, item.field)"
              minlength="2"
              maxlength="20"
            ></el-input>
            <span v-else>{{ row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </vxe-grid>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'DeductionRow',
    props: {
      deductionList: {
        type: Array,
        default: () => [],
      },
      isCreate: {
        type: Boolean,
        require: true,
      },
    },
    data() {
      return {
        tableData: [
          // {
          //   payableSettlementNo: '1',
          //   originalTotalAmount: '2',
          //   currencyName: 'CNC',
          //   exchangeRate: '2',
          //   domesticTotalAmount: '4',
          // },
        ],
        tableRules: { deductionDesc: [{ required: true, message: '必填字段' }] },
        tableColumnList: [
          {
            type: 'checkbox',
            visible: true,
            width: '50',
            fixed: 'left',
          },
          {
            field: 'deductionDesc',
            title: '抵扣说明',
            visible: true,
            editRender: { name: 'deductionDesc' },
          },
          // {
          //   field: 'settlementDesc',
          //   title: '结算说明',
          //   visible: true,
          // },

          {
            field: 'deductionOriginalAmount',
            title: '抵扣原币金额（含税）',
            visible: true,
          },
          {
            field: 'currencyName',
            title: '币种',
            visible: true,
          },
          // {
          //   field: 'exchangeRate',
          //   title: '汇率',
          //   width: '140',
          //   editRender: { name: 'exchangeRate' },
          // },
          // {
          //   field: 'deductionDomesticAmount',
          //   title: '抵扣本币金额（含税）',
          //   visible: true,
          // },
        ],
        selectionList: [],
      };
    },
    watch: {
      deductionList: {
        handler(val) {
          if (val && Array.isArray(val) && val.length) {
            console.log(11111111);
            this.fullFetchTableData(val);
          }
        },
        immediate: true,
        deep: true,
      },
    },

    methods: {
      async validAllEvent() {
        const $table = this.$refs.deductionRow;
        const errMap = await $table.validate().catch((errMap) => errMap);
        if (errMap) {
          this.$message.error('请检查数据再提交');
          return true;
        } else {
          return false;
        }
      },
      async closeEditTableHandler() {
        const $table = this.$refs?.deductionRow;
        const errMap = await $table.validate().catch((errMap) => errMap);
        if (errMap) {
          this.$message.error('请检查数据再提交');
        } else {
          // 派发事件
          const tableData = this.getTableData();
          this.$emit('closeEditDeductTableRowHandler', tableData);
        }
      },
      handleChange(row, field) {
        console.log(row, field, '行');
        // if (field === 'currencyCode') {
        //   row['currencyName'] = this.currencyList?.find(
        //     (item) => item.value == row['currencyCode']
        //   )?.label;
        // } else if (field === 'originalAmount') {
        //   row['domesticAmount'] = (row['originalAmount'] * row['exchangeRate']).toFixed(2);
        // }
      },
      //插入表格数据
      fullFetchTableData(val) {
        this.$nextTick(() => {
          this.insertEvent(val[0], 0);
        });
      },
      async insertEvent(rowData = {}, index = 0) {
        const $table = this.$refs.deductionRow;
        $table.remove(this.getTableData()); //先删除表格所有数据
        const errMap = await $table.validate().catch((errMap) => errMap);
        if (!errMap) {
          const { row: newRow } = await $table.insertAt(rowData, index);
          // await $table.setActiveRow(newRow); // 设置当前行为活跃
          await $table.validate(newRow).catch((errMap) => errMap);
        }
      },
      getTableData() {
        const $table = this.$refs?.deductionRow;
        return $table?.getTableData().fullData;
      },
      //选择合同移除所有行
      removeRowHandler() {
        console.log(this.getTableData(), 'this.getTableData()');
        console.log(this.getTableData()[0].id, 'this.getTableData()[0].id');
        let deleteDeductionId = this.getTableData()[0].id || null;
        this.$emit('saveDeleteDeductionId', deleteDeductionId);
        console.log(deleteDeductionId, 'deleteDeductionId');
        const $table = this.$refs.deductionRow;
        $table.remove(this.getTableData()); //先删除表格所有数据
      },
      deleteBtnClickHandler() {
        if (!this.selectionList.length) {
          this.$message.error('请选择行操作');
          return;
        }
        console.log(this.selectionList);
        let deleteDeductionId = this.selectionList[0]?.id || null;
        console.log(deleteDeductionId, 'deleteDeductionId');
        this.tableData = [];
        this.$emit('deleteDeductTableHandler', deleteDeductionId);
      },
      handleSelectionChange({ selection }) {
        console.log(selection, '选择行');
        this.selectionList = selection;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .related-row {
    background: #fff;
    .table-container {
      padding: 10px;
      box-sizing: border-box;
      padding-top: 0;
    }
  }
</style>
